var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReset = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M5.1725 5.17251C4.735 5.61001 4.42 6.12251 4.2275 6.66751C4.08 7.08501 3.6225 7.30251 3.2075 7.15501C2.7925 7.00751 2.5725 6.55001 2.72 6.13501C2.99 5.36751 3.43 4.65001 4.04 4.04001C6.22 1.86001 9.7475 1.85251 11.935 4.01501L12.975 2.97501C13.1475 2.80251 13.405 2.75251 13.63 2.84501C13.855 2.93751 14 3.15751 14 3.40001V6.60001C14 6.93251 13.7325 7.20001 13.4 7.20001H13.19H10.2C9.9575 7.20001 9.7375 7.05501 9.645 6.83001C9.5525 6.60501 9.6025 6.34751 9.775 6.17501L10.8025 5.14751C9.2375 3.61001 6.725 3.61751 5.17 5.17251H5.1725ZM2 9.40001C2 9.06751 2.2675 8.80001 2.6 8.80001H2.79H2.8075H5.8C6.0425 8.80001 6.2625 8.94501 6.355 9.17001C6.4475 9.39501 6.3975 9.65251 6.225 9.82501L5.1975 10.8525C6.7625 12.39 9.275 12.3825 10.83 10.8275C11.2675 10.39 11.5825 9.87751 11.775 9.33251C11.9225 8.91501 12.38 8.69751 12.795 8.84501C13.21 8.99251 13.43 9.45001 13.2825 9.86501C13.0125 10.63 12.5725 11.3475 11.96 11.96C9.78 14.14 6.2525 14.1475 4.065 11.985L3.025 13.025C2.8525 13.1975 2.595 13.2475 2.37 13.155C2.145 13.0625 2 12.8425 2 12.6V9.61001V9.59251V9.40251V9.40001Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgReset);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "3ce0e691224c53dcbdaf9accb45e8e39.svg";